import Alpine from "../alpine.js"
import { client } from "../client.js"

Alpine.data("profilePhoto", ({ userId, storageUrl }) => ({
  userId,
  storageUrl,
  submitting: false,
  fileInputChange (event) {
    this.submitting = true
    let file = event.target.files[0]

    return client.get(`/users/${userId}/picture/new/`)
      .then((response) => {
        // Form Data entries need to be ordered or aws complains so the
        // key needs to come before the file attribute
        let formData = new FormData()
        Object.keys(response).forEach((key, index) => {
          formData.append(key, response[key])
        })
        formData.append("file", file)

        return fetch(this.storageUrl, {
          headers: { "Accept": "application/json" },
          method: "POST",
          body: formData
        })
      })
      .then((storageReponse) => { return storageReponse.text() })
      .then((xml) => {
        let parser = new DOMParser()
        xmlDoc = parser.parseFromString(xml, "application/xml")
        let key = xmlDoc.querySelector('Key').innerHTML
        return key
      })
      .then((key) => { return client.post(`/users/${userId}/picture`, { picture_key: key }) })
      .then((response) => { window.location.reload(true) })
      .catch((error) => { this.submitting = false; console.log({ error }) })
  }
}))
